const UPLOAD_SPREADSHEET_STEP = 'uploadSpreadSheet';
const ADD_TAG_STEP = 'addStep';
const REVIEW_IMPORT_STEP = 'reviewImport';

export { ADD_TAG_STEP, REVIEW_IMPORT_STEP, UPLOAD_SPREADSHEET_STEP };
